import { AiToolbar, MarkdownTextAi } from '@mint-lib/ai-chat/components';
import { StarsGradient as StarsGradientIcon } from '@mint-lib/icons';
import { Card, typographyVariants } from '@mint-lib/tw-components';

import { useAiSidebarContext } from '../../../context.jsx';

const SuggestionOriginDetails = () => {
  const { selectedSuggestion } = useAiSidebarContext();
  const { typeOfRecommendation } = selectedSuggestion?.taxonomy || {};

  return typeOfRecommendation ? (
    <Card variant="outlined" className="border-none bg-background-default">
      <div className="mb-1 flex gap-2">
        <StarsGradientIcon />
        <p
          className={typographyVariants({
            variant: 'bodyShort02',
            color: 'secondary',
          })}
        >
          MINT AI
        </p>
      </div>
      <div className="group relative flex flex-col gap-1">
        <MarkdownTextAi text={typeOfRecommendation} />
        <AiToolbar text={typeOfRecommendation} isMobile={false} />
      </div>
    </Card>
  ) : null;
};
export default SuggestionOriginDetails;
